// Available shapes for high contrast mode
export const SHAPES = [
    'circle',
    'square',
    'triangle',
    'diamond',
    'star',
    'cross',
] as const

export type Shape = (typeof SHAPES)[number]

// Recharts legend type mapping
export const RECHARTS_LEGEND_TYPES: Record<
    Shape,
    'circle' | 'rect' | 'triangle' | 'diamond' | 'star' | 'cross'
> = {
    circle: 'circle',
    square: 'rect',
    triangle: 'triangle',
    diamond: 'diamond',
    star: 'star',
    cross: 'cross',
} as const
